export default {"src":"/_next/static/image/public/images/ic_timer.581091e7e9c3ac5bb652e3e498232954.svg","height":18,"width":18};